const React = require('react');
const loopMap = require('mn-utils/loopMap');
const StarIcon = require('@material-ui/icons/Star').default;
const StarOutlineIcon = require('@material-ui/icons/StarBorder').default;
const StarHalfIcon = require('@material-ui/icons/StarHalf').default;


module.exports = (props) => {
  const value = (props.value || 0) / 20;
  return (
    <div className="layoutRow fhaS fvaC">
      {loopMap(5, (i) => {
        const v = value - i;
        const Star = v > 0.7
          ? StarIcon
          : (v < 0.3 ? StarOutlineIcon : StarHalfIcon);
        return (<Star key={i}/>);
      })}
    </div>
  );
};
